import type { z } from 'zod'

/**
 * Zod parse with a DEV-only diagnostic dump. Production behaviour is identical
 * to `schema.parse` (throw on failure); in development we also log the issue
 * paths so a single bad field no longer looks like a mysterious empty page.
 *
 * Accepts any Zod schema (including ZodEffects / transforms like `zId`) via
 * `ZodTypeAny` so envelope helpers type-check cleanly.
 */
export function parseContract<S extends z.ZodTypeAny>(
  schema: S,
  data: unknown,
  label: string,
): z.output<S> {
  const result = schema.safeParse(data)
  if (result.success) return result.data

  if (import.meta.env.DEV) {
    console.error(`[api-contract] ${label} failed`, {
      issues: result.error.issues.map((issue) => ({
        path: issue.path.join('.') || '(root)',
        code: issue.code,
        message: issue.message,
      })),
    })
  }

  throw result.error
}
